<template>
    <div class="flex flex-col w-full">
        
        <!-- Footer -->
        <footer class="bg-black text-white">
            <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
                <div class="grid grid-cols-1 md:grid-cols-12 gap-x-8 gap-y-12">
                    <!-- Shops -->
                    <div class="md:col-span-2">
                        <h5 class="text-2xl font-bold mb-6 text-white/90">Shops</h5>
                        <nav class="flex flex-col space-y-4">
                            <RouterLink
                                v-for="location in locations" 
                                :key="location.city" 
                                :to="location.path"
                                class="text-white/70 hover:text-orange-400 transition-colors duration-200 text-sm">
                                {{ location.city }}
                            </RouterLink>
                        </nav>
                    </div>
                    
                    <!-- Services -->
                    <div class="md:col-span-2">
                        <h5 class="text-2xl font-bold mb-6 text-white/90">Services</h5>
                        <nav class="flex flex-col space-y-4">
                            <RouterLink
                                v-for="service in services" 
                                :key="service.name"
                                :to="service.path"
                                class="text-white/70 hover:text-orange-400 transition-colors duration-200 text-sm">
                                {{ service.label }}
                            </RouterLink>
                        </nav>
                    </div>
                    
                    <!-- Plaza -->
                    <div class="md:col-span-2">
                        <h5 class="text-2xl font-bold mb-6 text-white/90">Plaza</h5>
                        <nav class="flex flex-col space-y-4">
                            <RouterLink
                                v-for="item in plazaItems"
                                :key="item.title"
                                :to="item.path"
                                class="text-white/70 hover:text-orange-400 transition-colors duration-200 text-sm">
                                {{ item.title }}
                            </RouterLink>
                        </nav>
                    </div>
                    
                    <!-- Social Icons -->
                    <div class="md:col-span-6 flex md:justify-end items-center space-x-8">
                        <a v-for="social in socialIcons"
                           :key="social.label"
                           :href="social.url" 
                           target="_blank"
                           rel="noopener noreferrer"
                           class="text-white/70 hover:text-orange-400 transition-colors duration-200"
                           :aria-label="social.label">
                            <FontAwesomeIcon 
                                :icon="social.icon" 
                                class="w-8 h-8"
                            />
                        </a>
                    </div>
                </div>
                
                <!-- Copyright Section -->
                <div class="mt-12 pt-8 border-t border-white/10">
                    <div class="text-center text-white/50 text-sm">
                        © {{ new Date().getFullYear() }} All Rights Reserved.
                    </div>
                </div>
            </div>
        </footer>
    </div>
</template>

<script lang="ts" setup>
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faFacebookF, faYelp, faAmazon } from '@fortawesome/free-brands-svg-icons'
import { SERVICES } from '../config/services';
import { locations } from '../config/locations';

library.add(faFacebookF, faYelp, faAmazon);

interface PlazaItem {
    title: string;
    path: string;
}

const socialIcons = [
    { 
        icon: faFacebookF, 
        label: 'Facebook',
        url: 'https://facebook.com/yourpage'
    },
    { 
        icon: faYelp, 
        label: 'Yelp',
        url: 'https://yelp.com/biz/yourbusiness'
    },
    { 
        icon: faAmazon, 
        label: 'Amazon',
        url: 'https://amazon.com/yourstore'
    }
];

const services = SERVICES;

const plazaItems: PlazaItem[] = [
    {
        title: 'About Us',
        path: '/about'
    },
    {
        title: 'The Little Black Van',
        path: '/about'
    }
];
</script>